import { render } from "./SectionPriceSelectItem.vue?vue&type=template&id=ac3fbee0&scoped=true"
import script from "./SectionPriceSelectItem.vue?vue&type=script&lang=js"
export * from "./SectionPriceSelectItem.vue?vue&type=script&lang=js"

import "./SectionPriceSelectItem.vue?vue&type=style&index=0&id=ac3fbee0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac3fbee0"]])

export default __exports__